import { all, takeLatest, put, retry, call } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { Api } from '$api';
import { batchActions } from '$store';
import { mainActions } from '$store/main';
import { giftsActions } from '$store/gifts/index';
import { showModal } from '$navigation/helper';

function* loadGiftsWorker(action: PayloadAction<number>) {
  try {
    const data = yield retry(Infinity, 3000, Api.get, '/gifts/store', {
      params: {
        to_id: action.payload,
      },
    });
    yield put(
      batchActions(
        mainActions.setUser(data.user),
        giftsActions.setLoadingStatus(''),
        giftsActions.setGifts(data.gifts),
        giftsActions.setSpecial({
          title: data.specialTitle,
          gifts: data.specialIds,
        }),
      ),
    );
  } catch (e) {}
}

function* showSendWorker() {
  yield call(showModal, 'send_gift');
}

export function* giftsSaga() {
  yield all([
    takeLatest(giftsActions.loadGifts, loadGiftsWorker),
    takeLatest(giftsActions.showSend, showSendWorker),
  ]);
}
